import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT

//region 管理租户
//获取列表数据
export const sysmanageList = (params) => {
  return axios.get(root + '/sysmanage/managingtenant/list', {params: params})
}


//获取某一行的明细数据
export const sysmanageDetail = (params) => {
  return axios.get(root + '/sysmanage/managingtenant/detail', {params: params})
}

//保存某一行的数据
export const sysmanagesaveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/tenant/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/sysmanage/managingtenant/save', qs.stringify(params))
  }
}
//endregion

//region 维护参数
//获取列表数据
export const parameterMaintainList = (params) => {
  return axios.get(root + '/sysmanage/ParameterMaintain/list', {params: params})
}
//修改维护参数
export const sysupdateparacontent = (params) => {
  return axios.get(root + '/sysmanage/ParameterMaintain/sysupdateparacontent', {params: params})
}

//endregion

//region 运行数据
export const runDataList = (params) => {
  return axios.get(root + '/sysmanage/RunData/list', {params: params})
}
//endregion
//region 授权品牌
export const tongbuBrand = (params) => {
  return axios.get(root + '/sysmanage/ShouQuanBrand/tongbuBrand', {params: params})
}
//endregion



// WEBPACK FOOTER //
// ./src/api/sysmanage/sysmanage.js